module.exports = __webpack_public_path__ + "static/media/aboutls.1244036c.jpg";